import { call, put, takeLatest } from 'redux-saga/effects';
import { REGIS } from '../../constants/auth/regis';

import {
  registerFailed,
  registerSuccess
} from '../../actions/auth/regis';

import { register } from '../../../services/AuthService';

function* registerSaga(data) {
  try {
    let payload = {
      email: data.data.email,
      type: 'Consumer',
      password: data.data.password,
      date_of_birth: data.data.date_of_birth,
      full_name: data.data.full_name,
      phone_number: data.data.phone_number,
      phone_country_code: data.data.phone_country_code,
      elearning_platform: window.location.hostname,
      gender: data.data.gender,
      postal_code: '00000', // Temporary workaround
      bio: '',
    };

    // Only add provider fields if they exist and are not undefined
    if (data.data.provider && data.data.provider !== 'undefined') {
      payload = {
        ...payload,
        provider: data.data.provider,
        providerId: data.data.providerId,
      };
    }

    console.info('Registration payload:', payload);

    // console.log('Sending registration payload:', payload); // Debug log

    const registerReq = yield call(register, payload);

    // console.log('Registration response:', registerReq); // Debug log

    if (registerReq.status === 200) {
      yield put(registerSuccess(registerReq));
    } else {
      yield put(registerFailed(registerReq));
    }
  } catch (error) {
    // console.error('Registration error:', error); // Debug log
    yield put(registerFailed(error));
  }
}

function* watchSaga() {
  yield takeLatest(REGIS.REGISTER, registerSaga);
}

export default watchSaga;
